export enum AutopayText {
  Yes = 'Yes',
  No = 'No',
  ErrorMessage = 'Please Select Autopay Option',
}
